import HeaderTab from "../HeaderTab"
import MobileMenu from "../MobileMenu"
import 'style.css'
import { useState, useEffect, useCallback } from "react"

const Header = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1082);
    // const [ setWindowWidth] = useState(window.innerWidth);
    // windowWidth,
    // Use useCallback to memoize the function
    const checkIfMobile = useCallback(() => {
        const currentWidth = window.innerWidth;
        // setWindowWidth(currentWidth); this was unused so now it's good
        setIsMobile(currentWidth <= 1082);
    }, []);
    
    // Check if the screen is mobile size
    useEffect(() => {
        // Initial check
        checkIfMobile();
        
        // Add event listener for window resize
        window.addEventListener('resize', checkIfMobile);
        
        // Clean up
        return () => {
            window.removeEventListener('resize', checkIfMobile);
        };
    }, [checkIfMobile]);

    const tabs = [
        ["ABOUT US", "/"],
        ["THE FLEET", "/fleet"],
        ["OUR TEAM", "/our-team"],
        ["GALLERY", "/gallery"],
        ["UPDATES", "/blog"],
        ["CONNECT", "/contact"]
    ] as Array<[string, string | null, Array<[string, string]>?]>;
    
    return (
        <div className="header" id="headNav" style={{
            position: "fixed",
            zIndex: 5,
            backgroundColor: "var(--color-nav-bg)",
            width: "100%",
            height: "72px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
        }}>
            {!isMobile && (
                <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "center", gap: "10px",}}>
                    <a href="/" style={{display: "flex", textDecoration: 'none', alignItems: 'center'}}>
                        <img style={{ height: "40px", width: "40px" }} src= "/images/logos/surfLogoWhite.png" alt="" />
                        <h1 style={{ padding:'10px', color: "var(--color-primary)", fontWeight: "700", fontSize: "39px", fontFamily: "'NCAA Missouri Tigers', Arial", }}>Mizzou Surf</h1>
                    </a>
                </div>
            )}
            
            {isMobile ? (
                <MobileMenu tabs={tabs} />
            ) : (
                <div className="desktop-menu" style={{ display: "inherit", justifyContent: "flex-start", width: "100%", marginRight: "100px", whiteSpace: "nowrap", }}>
                    {tabs.map((tab, index) => (
                        <HeaderTab 
                            key={index} 
                            tabName={tab[0] as string} 
                            tabLink={tab[1] as string} 
                            subMenu={tab[2] as Array<Array<string>> | undefined} 
                        />
                    ))}
                </div>
            )}
        </div>
    )
}
export default Header